var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSucessoEnvio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_130",
    "data-name": "Caminho 130",
    d: "M43,16A27,27,0,1,0,70,43,27.079,27.079,0,0,0,43,16ZM55.487,38.613l-13.5,13.5a3.262,3.262,0,0,1-4.725,0l-6.75-6.75a3.341,3.341,0,0,1,4.725-4.725l4.388,4.387L50.762,33.888a3.341,3.341,0,0,1,4.725,4.725Z",
    transform: "translate(-16 -16)",
    fill: "#005a9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSucessoEnvio);
export default __webpack_public_path__ + "static/media/check-sucesso-envio.f63d8a4fc8df7c1a83da2a06c516dea0.svg";
export { ForwardRef as ReactComponent };